const moduleOrder = [
  'portal-aplikasi'
]
export default moduleOrder



// WEBPACK FOOTER //
// ./src/modules/_order.js